import React from 'react';
import Button from '@/components/Button';
import { Body } from '@/components/Typography';
import { AssessmentHealthRow } from '@/services/assessmentsAPI';
import { formatDuration, progressLabel } from './helpers';

interface Props {
  rows: AssessmentHealthRow[];
  onRerun: (row: AssessmentHealthRow) => void;
  busyExternalId: string | null;
}

const cell: React.CSSProperties = {
  padding: '8px 12px',
  borderBottom: '1px solid #eee',
  verticalAlign: 'top',
};

const HealthTable: React.FC<Props> = ({ rows, onRerun, busyExternalId }) => (
  <div style={{ overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
      <thead>
        <tr>
          {[
            'Worker',
            'Skill',
            'Status',
            'Progress',
            'Stuck for',
            'Code',
            'Provider',
            '',
          ].map((h) => (
            <th key={h} style={{ ...cell, textAlign: 'left', fontWeight: 600 }}>
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.external_id}>
            <td style={cell}>
              <Body>{row.worker_name || `User ${row.user_id}`}</Body>
              <div style={{ color: '#777', fontSize: 12 }}>
                {row.phone || ''}
              </div>
            </td>
            <td style={cell}>{row.skill_name || row.skill_id}</td>
            <td style={cell}>
              {row.status}
              {row.is_stuck && (
                <span
                  style={{
                    marginLeft: 8,
                    color: '#DC1515',
                    fontWeight: 700,
                    fontSize: 12,
                  }}
                >
                  STUCK
                </span>
              )}
            </td>
            <td
              style={{
                ...cell,
                color:
                  row.questions_transcribed === row.questions_total &&
                  row.questions_scored === 0
                    ? '#DC1515'
                    : undefined,
              }}
            >
              {progressLabel(row)}
            </td>
            <td style={cell}>{formatDuration(row.stuck_for_seconds)}</td>
            <td style={cell}>{row.auth_code || '—'}</td>
            <td style={cell}>{row.ai_provider || '—'}</td>
            <td style={cell}>
              <Button
                onClick={() => onRerun(row)}
                a11yLabel={`Re-run scoring for ${row.external_id}`}
                label={
                  busyExternalId === row.external_id
                    ? 'Queuing…'
                    : 'Re-run scoring'
                }
                disabled={busyExternalId === row.external_id}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default HealthTable;
